import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { GitCompareArrows } from 'lucide-react';

export function VideoDuelHeader() {
  useLanguage();
  return (
    <div className="-mx-4 sm:-mx-6">
      <div className="px-4 sm:px-6 pb-4">
        <div className="flex items-center gap-2.5">
          <GitCompareArrows className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />
          <h1 className="text-[20px] font-medium text-[#1E2330] tracking-tight leading-[1.2]">
            {translateInterfaceText("Comparar VSL")}</h1>
        </div>
      </div>
      <div
        className="hidden lg:block h-px w-full"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)' }}
      />
    </div>
  );
}
